module.exports = __webpack_public_path__ + "img/group-none.2c560350.svg";